// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"20d8abeb","257":"12fcbcf4","303":"75cbc886","356":"1f19d935","418":"4c8fe9db","453":"54342de2","630":"17328cf4","725":"3e78d5c7","985":"022c7e57"}[chunkId] + ".chunk.js";
};